var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
export var sizeMap = {
    large: {
        borderRadius: '6px',
        fontSize: tokens.fontSizes.medium,
        sizing: '12px',
        spacing: tokens.spacing.medium,
    },
    medium: {
        borderRadius: tokens.borderRadius.medium,
        fontSize: tokens.fontSizes.small,
        sizing: '8px',
        spacing: tokens.spacing.medium,
    },
    small: {
        borderRadius: '2px',
        fontSize: tokens.fontSizes.xsmall,
        sizing: '4px',
        spacing: tokens.spacing.small,
    },
};
var variantMap = {
    default: {
        backgroundColor: theme.brand.main,
    },
    error: {
        backgroundColor: theme.error.main,
    },
    upgrade: {
        backgroundColor: theme.upgrade.main,
    },
    warning: {
        backgroundColor: theme.warning.lighter,
    },
};
var wrapperStaticStyle = css({
    alignItems: 'center',
    color: theme.text.subtle,
    display: 'flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    gap: tokens.spacing.small,
    lineHeight: tokens.lineHeights.tight,
    width: '100%',
});
export function wrapperStyle(_a) {
    var inverted = _a.inverted, size = _a.size;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [
        wrapperStaticStyle,
        css({
            fontSize: sizeMap[size].fontSize,
        }),
    ], false);
}
export var progressWrapperStaticStyle = css({
    display: 'inline-flex',
    flex: 1,
    position: 'relative',
    width: '100%',
});
export var stepClipWrapperStaticStyle = css({
    display: 'flex',
    flexWrap: 'nowrap',
    height: '1px',
    position: 'absolute',
    width: '100%', // Height must be set to at least 1px for Safari to behave
});
export function stepClipStyle(_a) {
    var index = _a.index, max = _a.max, size = _a.size;
    // startPosX is for determining start location
    var startPosX = "".concat((100 / max) * index, "%");
    var width = "".concat(100 / max, "%");
    //  Emotion does not like the 'x' attribute, but it is supported in all modern browsers
    return css({
        height: sizeMap[size].sizing,
        width: "calc(".concat(startPosX === '0%' ? width : "".concat(width, " - 4px"), ")"),
        x: "calc(".concat(startPosX === '0%' ? 0 : "".concat(startPosX, " + 4px"), ")"),
    });
}
var progressIndicatorStaticStyle = css({
    transition: 'width 1s ease-in-out',
});
function progressIndicatorStyle(_a) {
    var size = _a.size, variant = _a.variant;
    return [
        progressIndicatorStaticStyle,
        css({
            backgroundColor: variantMap[variant].backgroundColor,
            borderRadius: sizeMap[size].borderRadius,
        }),
    ];
}
var progressStaticStyle = css({
    '&::-webkit-progress-bar': {
        backgroundColor: 'inherit',
    },
    appearance: 'none',
    backgroundColor: theme.transparentGrey.lighter,
    border: 'none',
    width: '100%',
});
export function progressStyle(_a) {
    var clipId = _a.clipId, size = _a.size, variant = _a.variant;
    return [
        progressStaticStyle,
        css({
            // Progress value indicator
            '&::-moz-progress-bar': progressIndicatorStyle({ size: size, variant: variant }),
            // Container for the progress indicator
            '&::-webkit-progress-bar': {
                borderRadius: sizeMap[size].borderRadius,
            },
            // Cannot use comma separated list due to common issue with these pseudo-selectors
            '&::-webkit-progress-value': progressIndicatorStyle({ size: size, variant: variant }),
            borderRadius: sizeMap[size].borderRadius,
            clipPath: "url(#".concat(clipId, ")"),
            height: sizeMap[size].sizing,
        }),
    ];
}
